// extracted by mini-css-extract-plugin
export default {"navigation":"previousBillsDialog_navigation__7xj1g"};